module.exports = __webpack_public_path__ + "static/media/multiple.1d4f2438.png";